import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class TraFormatService {

  constructor(
      private http: HttpClient,
  ) { }

  extractAccountingFolder$(
    remoteFileId: string
  ): Observable<Blob> {
    const url = `${environment.apiURL}/tools/tra-format-extraction`;

    return this.http.post(url, {remoteFileId}, {responseType: 'blob'});
  }
}
